
import { Component, Vue } from "vue-property-decorator";

interface KidemForm {
  brutMaas: number | null;
  calismaSuresiYil: number | null;
  digerOdemeler: number | null;
}

interface KidemResponse {
  kidem_tazminati: number;
  aciklama: string;
}

@Component
export default class KidemTazminatiHesaplayici extends Vue {
  form: KidemForm = {
    brutMaas: null,
    calismaSuresiYil: null,
    digerOdemeler: null,
  };
  sonuc: KidemResponse | null = null;
  yukleniyor: boolean = false;
  genelHataMesaji: string | null = null;

  get formGecerli(): boolean {
    return (
        this.form.brutMaas !== null &&
        this.form.brutMaas >= 0 &&
        this.form.calismaSuresiYil !== null &&
        this.form.calismaSuresiYil >= 0
    );
  }

  // TL format
  tlFormat(sayi: number | null | undefined): string {
    if (sayi === null || sayi === undefined) return "";
    return sayi.toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  handleApiError(error: any) {
    if (error && error.response && error.response.data) {
      const data = error.response.data;
      if (data.errors) {
        const messages = Object.values(data.errors).flat();
        if (messages.length > 0) {
          this.genelHataMesaji = messages.join('\n');
          return;
        }
      }
      if (typeof data === "string") {
        this.genelHataMesaji = data;
      } else if (data.message) {
        this.genelHataMesaji = data.message;
      } else {
        this.genelHataMesaji = "Beklenmeyen bir hata oluştu.";
      }
    } else {
      this.genelHataMesaji = "Sunucuya ulaşılamadı.";
    }
  }

  async hesapla() {
    if (!this.formGecerli) return;
    this.yukleniyor = true;
    this.sonuc = null;
    this.genelHataMesaji = null;

    try {
      const response = await (this as any).$http.post(
          "/api/v1/hesaplayicilar/kidem-tazminati",
          {
            brut_aylik_maas: this.form.brutMaas,
            calisma_suresi_yil: this.form.calismaSuresiYil,
            diger_odemeler: this.form.digerOdemeler,
          }
      );
      const data = response.data || response;
      this.sonuc = data;

    } catch (e) {
      this.handleApiError(e);
    } finally {
      this.yukleniyor = false;
    }
  }
}
